<template>
    <svg 
        :width="width"
        :height="height"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
        <g data-name="Layer 2">
            <g data-name="minus">
                <rect width="24"
                      height="24"
                      transform="rotate(180 12 12)"
                      opacity="0" />
                <path :fill="color"
                      d="M19 13H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z" />
            </g>
        </g>
    </svg>
</template>

<script>
import icon from '@/mixins/icon.mixin'

export default {mixins: [icon]}
</script>

<style>

</style>
